var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.775,
    height: 36.869,
    viewBox: "0 0 63.775 36.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-1833077",
    transform: "translate(63.46 0.635) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13679",
    "data-name": "Group 13679",
    transform: "translate(0.557 0.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13678",
    "data-name": "Group 13678",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10990",
    "data-name": "Path 10990",
    d: "M4.8,1.555A2.524,2.524,0,0,0,1.235,5.122L28.157,32.044,1.235,58.023A2.524,2.524,0,0,0,4.8,61.59L34.82,32.044Z",
    transform: "translate(-0.557 -0.877)",
    fill: "#2c53bb",
    stroke: "#2c53bb",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2326c8c823092da60ddbf7dac8450216.svg";
export { ForwardRef as ReactComponent };